// extracted by mini-css-extract-plugin
export var afterHover = "index-module--afterHover--59e47";
export var black = "index-module--black--84da6";
export var current = "index-module--current--e501c";
export var icon = "index-module--icon--eddd2";
export var text = "index-module--text--adbc9";
export var textContainer = "index-module--textContainer--2ee2f";
export var white = "index-module--white--451b5";